import { Controller } from "@hotwired/stimulus"

// Shared PWA reload action. Clears all SW caches, unregisters service workers,
// then hard-reloads. Used by both field and chat More pages.
export default class extends Controller {
  static targets = ["button"]

  async reload() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.textContent = "Reloading..."
    }

    try {
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        await Promise.all(registrations.map(r => r.unregister()))
      }
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    } catch (_) {
      // Best-effort -- proceed with reload regardless
    }

    window.location.reload()
  }
}
